import ConfirmDialog from '../components/ConfirmDialog';
import React, { useState, useEffect } from 'react';
import { toast } from '../components/Toast';
import Layout from '../components/Layout';
import api from '../services/api';

const CURRENCIES = [
  { code: 'USD', symbol: '$', locale: 'en-US', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', locale: 'de-DE', name: 'Euro' },
  { code: 'GBP', symbol: '£', locale: 'en-GB', name: 'British Pound' },
  { code: 'CAD', symbol: 'CA$', locale: 'en-CA', name: 'Canadian Dollar' },
  { code: 'MXN', symbol: 'MX$', locale: 'es-MX', name: 'Mexican Peso' },
  { code: 'BRL', symbol: 'R$', locale: 'pt-BR', name: 'Brazilian Real' },
  { code: 'COP', symbol: 'COL$', locale: 'es-CO', name: 'Colombian Peso' },
  { code: 'ARS', symbol: 'ARS$', locale: 'es-AR', name: 'Argentine Peso' },
  { code: 'CLP', symbol: 'CL$', locale: 'es-CL', name: 'Chilean Peso' },
  { code: 'PEN', symbol: 'S/', locale: 'es-PE', name: 'Peruvian Sol' },
  { code: 'VES', symbol: 'Bs.', locale: 'es-VE', name: 'Venezuelan Bolivar' },
  { code: 'DOP', symbol: 'RD$', locale: 'es-DO', name: 'Dominican Peso' },
  { code: 'AUD', symbol: 'A$', locale: 'en-AU', name: 'Australian Dollar' },
  { code: 'JPY', symbol: '¥', locale: 'ja-JP', name: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥', locale: 'zh-CN', name: 'Chinese Yuan' },
  { code: 'INR', symbol: '₹', locale: 'en-IN', name: 'Indian Rupee' },
  { code: 'AED', symbol: 'د.إ', locale: 'ar-AE', name: 'UAE Dirham' },
  { code: 'SAR', symbol: '﷼', locale: 'ar-SA', name: 'Saudi Riyal' },
  { code: 'CHF', symbol: 'CHF', locale: 'de-CH', name: 'Swiss Franc' },
  { code: 'KRW', symbol: '₩', locale: 'ko-KR', name: 'South Korean Won' },
];

const TIMEZONES = [
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
  'America/Anchorage', 'Pacific/Honolulu', 'America/Puerto_Rico',
  'America/Mexico_City', 'America/Bogota', 'America/Lima', 'America/Caracas',
  'America/Santiago', 'America/Buenos_Aires', 'America/Sao_Paulo',
  'Europe/London', 'Europe/Paris', 'Europe/Berlin', 'Europe/Madrid',
  'Asia/Dubai', 'Asia/Tokyo', 'Asia/Shanghai', 'Asia/Seoul', 'Asia/Kolkata',
  'Australia/Sydney', 'Pacific/Auckland'
];

const Settings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');
  const [licenses, setLicenses] = useState([]);
  const [showLicenseModal, setShowLicenseModal] = useState(false);
  const [editingLicense, setEditingLicense] = useState(null);
  const [licenseForm, setLicenseForm] = useState({ state: '', license_number: '', license_type: 'Pest Control', expiry_date: '', issued_by: '' });
  const [confirmDialog, setConfirmDialog] = useState(null);
  const [emailSettings, setEmailSettings] = useState({
    display_name: '',
    proposals:     { from_name: '', from_email: '', reply_to: '' },
    reports:       { from_name: '', from_email: '', reply_to: '' },
    invoices:      { from_name: '', from_email: '', reply_to: '' },
    notifications: { from_name: '', from_email: '', reply_to: 'no-reply' },
  });
  const [emailSaving, setEmailSaving] = useState(false);
  const [emailSaved, setEmailSaved] = useState(false);
  const [testEmailSending, setTestEmailSending] = useState(false);
  const [testEmailAddress, setTestEmailAddress] = useState('');
  const [invoiceSeq, setInvoiceSeq] = useState({ prefix: 'INV-', next_number: 1001, padding: 4 });
  const [invoiceSeqSaving, setInvoiceSeqSaving] = useState(false);
  const [invoiceSeqSaved, setInvoiceSeqSaved] = useState(false);

  const [invoiceProfile, setInvoiceProfile] = useState({
    country: 'usa',
    tagline: '',
    address: '', city: '', state: '', zip_code: '',
    phone: '', email: '', ein: '',
    payment_terms: 'Net 30',
    payment_instructions: '',
    legal_note: '',
    top_margin_cm: 7,
    default_tax_rate: 0,
  });
  const [invoiceProfileSaving, setInvoiceProfileSaving] = useState(false);
  const [invoiceProfileSaved, setInvoiceProfileSaved] = useState(false);
  const [taxCategories, setTaxCategories]   = useState([]);
  const [taxCatLoading, setTaxCatLoading]   = useState(false);
  const [taxCatForm, setTaxCatForm]         = useState({ country:'usa', code:'', name:'', description:'', rate:0, is_exempt:false, is_zero_rated:false });
  const [taxCatAdding, setTaxCatAdding]     = useState(false);
  const [taxCatSaving, setTaxCatSaving]     = useState(false);

  const [opSettings, setOpSettings] = useState({
    geo: {
      radius_meters: 500,
      required_technician: true,
      required_supervisor: false,
      required_manager: false,
      required_admin: false,
    },
    scan: {
      required_technician: true,
      required_supervisor: false,
      required_manager: false,
      required_admin: false,
    },
    report_emails: {
      allow_add: true,
      allow_edit_delete: false,
    }
  });
  const [opSaving, setOpSaving] = useState(false);
  const [opSaved, setOpSaved] = useState(false);
  const [reportDelivery, setReportDelivery] = useState({
    mode: 'auto_send',           // 'auto_send' | 'review_queue'
    reviewers: {
      supervisor: true,
      manager:    true,
      admin:      true,
    },
    digest_time:        '14:00',
    auto_release_time:  '18:00',
    review_window_days: 1,
    skip_weekends:      true,
  });
  const [rdSaving, setRdSaving] = useState(false);
  const [rdSaved,  setRdSaved]  = useState(false);
  // ── Pricing visibility (Sub-session C) ──────────────────────────────────
  const [pricingViz, setPricingViz] = useState({
    csr:        true,
    manager:    false,
    supervisor: false,
    router:     false,
    technician: false,
  });
  const [pricingSaving, setPricingSaving] = useState(false);
  const [pricingSaved,  setPricingSaved]  = useState(false);

  useEffect(() => { fetchSettings(); fetchLicenses(); fetchTaxCategories(); }, []);

  const fetchSettings = async () => {
    try {
      const res = await api.get('/companies/settings');
      const d = res.data.data;
      setSettings(d);
      // Pricing visibility hydration (Sub-session C)
      if (d.settings && d.settings.view_pricing) {
        const vp = d.settings.view_pricing;
        setPricingViz({
          csr:        vp.csr        !== undefined ? vp.csr        : true,
          manager:    vp.manager    === true,
          supervisor: vp.supervisor === true,
          router:     vp.router     === true,
          technician: vp.technician === true,
        });
      }
      if (d.settings && d.settings.report_delivery) {
        const rd = d.settings.report_delivery;
        setReportDelivery({
          mode: rd.mode || 'auto_send',
          reviewers: {
            supervisor: rd.reviewers?.supervisor ?? true,
            manager:    rd.reviewers?.manager    ?? true,
            admin:      rd.reviewers?.admin      ?? true,
          },
          digest_time:        rd.digest_time        || '14:00',
          auto_release_time:  rd.auto_release_time  || '18:00',
          review_window_days: rd.review_window_days || 1,
          skip_weekends:      rd.skip_weekends      !== false,
        });
      }
      if (d.settings && d.settings.operational) {
        const op = d.settings.operational;
        setOpSettings({
          geo: {
            radius_meters:       op.geo?.radius_meters       ?? 500,
            required_technician: op.geo?.required_technician ?? true,
            required_supervisor: op.geo?.required_supervisor ?? false,
            required_manager:    op.geo?.required_manager    ?? false,
            required_admin:      op.geo?.required_admin      ?? false,
          },
          scan: {
            required_technician: op.scan?.required_technician ?? true,
            required_supervisor: op.scan?.required_supervisor ?? false,
            required_manager:    op.scan?.required_manager    ?? false,
            required_admin:      op.scan?.required_admin      ?? false,
          },
          report_emails: {
            allow_add:         op.report_emails?.allow_add         ?? true,
            allow_edit_delete: op.report_emails?.allow_edit_delete ?? false,
          }
        });
      }
      // Load invoice sequence
      try {
        const seqRes = await api.get('/invoices/sequence');
        if (seqRes.data.success) {
          setInvoiceSeq({
            prefix: seqRes.data.prefix || 'INV-',
            next_number: seqRes.data.next_number || 1001,
            padding: seqRes.data.padding || 4,
          });
        }
      } catch(e) {}

      if (d.settings && d.settings.invoice_profile) {
        const ip = d.settings.invoice_profile;
        setInvoiceProfile({
          country:              ip.country              || 'usa',
          tagline:              ip.tagline              || '',
          address:              ip.address              || '',
          city:                 ip.city                 || '',
          state:                ip.state                || '',
          zip_code:             ip.zip_code             || '',
          phone:                ip.phone                || '',
          email:                ip.email                || '',
          ein:                  ip.ein                  || '',
          payment_terms:        ip.payment_terms        || 'Net 30',
          payment_instructions: ip.payment_instructions || '',
          legal_note:           ip.legal_note           || '',
          top_margin_cm:        ip.top_margin_cm        || 7,
          default_tax_rate:     ip.default_tax_rate     || 0,
        });
      }
      if (d.settings && d.settings.email_config) {
        setEmailSettings(prev => ({ ...prev, ...d.settings.email_config }));
      } else {
        setEmailSettings(prev => ({
          ...prev,
          display_name: d.name || '',
          proposals:     { from_name: d.name || '', from_email: d.email || '', reply_to: d.email || '' },
          reports:       { from_name: d.name || '', from_email: d.email || '', reply_to: d.email || '' },
          invoices:      { from_name: d.name || '', from_email: d.email || '', reply_to: d.email || '' },
          notifications: { from_name: d.name || '', from_email: d.email || '', reply_to: 'no-reply' },
        }));
      }
    } catch (err) {
      console.error(err);
      setError('Failed to load settings');
    }
    setLoading(false);
  };

  const fetchLicenses = async () => {
    try {
      const res = await api.get('/companies/licenses');
      setLicenses(res.data.data || []);
    } catch (err) { console.error('Error fetching licenses:', err); }
  };

  const handleLicenseSave = async () => {
    if (!licenseForm.state || !licenseForm.license_number) {
      toast.error('State and license number are required');
      return;
    }
    try {
      if (editingLicense) {
        await api.put('/companies/licenses/' + editingLicense.id, licenseForm);
      } else {
        await api.post('/companies/licenses', licenseForm);
      }
      fetchLicenses();
      setShowLicenseModal(false);
      setEditingLicense(null);
      setLicenseForm({ state: '', license_number: '', license_type: 'Pest Control', expiry_date: '', issued_by: '' });
    } catch (err) { toast.error('Error saving license'); }
  };

  const handleLicenseEdit = (lic) => {
    setEditingLicense(lic);
    setLicenseForm({
      state: lic.state, license_number: lic.license_number,
      license_type: lic.license_type || 'Pest Control',
      expiry_date: lic.expiry_date ? lic.expiry_date.substring(0, 10) : '',
      issued_by: lic.issued_by || ''
    });
    setShowLicenseModal(true);
  };

  const handleLicenseDelete = async (id) => {
    setConfirmDialog({ message: 'Delete this license? This cannot be undone.', confirmText: 'Delete', icon: '🗑', onConfirm: async () => {
      setConfirmDialog(null);
      try {
        await api.delete('/companies/licenses/' + id);
        fetchLicenses();
      } catch (err) { toast.error('Error deleting license'); }
    }});
  };

  const saveEmailSettings = async () => {
    setEmailSaving(true);
    setEmailSaved(false);
    try {
      const currentSettings = settings?.settings || {};
      await api.put('/companies/settings', {
        settings: { ...currentSettings, email_config: emailSettings }
      });
      setEmailSaved(true);
      setTimeout(() => setEmailSaved(false), 3000);
    } catch (err) { toast.error('Error saving email settings'); }
    setEmailSaving(false);
  };

  const sendTestEmail = async () => {
    if (!testEmailAddress) { toast.info('Please enter a test email address'); return; }
    setTestEmailSending(true);
    try {
      await api.post('/companies/test-email', { email_config: emailSettings, test_to: testEmailAddress });
      toast.success('Test email sent to ' + testEmailAddress);
    } catch (err) { toast.error('Error sending test email: ' + (err.response?.data?.message || err.message)); }
    setTestEmailSending(false);
  };

  const updateEmailType = (type, field, value) => {
    setEmailSettings(prev => ({ ...prev, [type]: { ...prev[type], [field]: value } }));
  };

  const US_STATES = [
    'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA',
    'KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
    'NM','NY','NC','ND','OH','OK','OR','PA','PR','RI','SC','SD','TN','TX','UT',
    'VT','VA','WA','WV','WI','WY','DC'
  ];

  const STATE_NAMES = {
    AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',
    CT:'Connecticut',DE:'Delaware',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',
    IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',
    ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',
    MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',
    NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',
    OR:'Oregon',PA:'Pennsylvania',PR:'Puerto Rico',RI:'Rhode Island',SC:'South Carolina',
    SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',
    WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming',DC:'Washington DC'
  };

  const handleCurrencyChange = (code) => {
    const curr = CURRENCIES.find(c => c.code === code);
    if (curr) {
      setSettings({ ...settings, currency: curr.code, currency_symbol: curr.symbol, currency_locale: curr.locale });
      setSaved(false);
    }
  };

  const saveReportDelivery = async () => {
    setRdSaving(true);
    setRdSaved(false);
    try {
      const currentRes = await api.get('/companies/settings');
      const existingSettings = currentRes.data.data.settings || {};
      const merged = { ...existingSettings, report_delivery: reportDelivery };
      await api.put('/companies/settings', { settings: merged });
      setRdSaved(true);
      setTimeout(() => setRdSaved(false), 3000);
    } catch (err) {
      toast.info('Failed to save report delivery settings');
    }
    setRdSaving(false);
  };

  // ── Save pricing visibility (Sub-session C) ────────────────────────────
  const savePricingVisibility = async () => {
    setPricingSaving(true);
    setPricingSaved(false);
    try {
      const currentRes = await api.get('/companies/settings');
      const existingSettings = currentRes.data.data.settings || {};
      const merged = { ...existingSettings, view_pricing: pricingViz };
      await api.put('/companies/settings', { settings: merged });
      setPricingSaved(true);
      setTimeout(() => setPricingSaved(false), 3000);
    } catch (err) {
      toast.error('Failed to save pricing visibility settings');
    }
    setPricingSaving(false);
  };

  const saveInvoiceSeq = async () => {
    setInvoiceSeqSaving(true);
    try {
      await api.put('/invoices/sequence', invoiceSeq);
      setInvoiceSeqSaved(true);
      setTimeout(() => setInvoiceSeqSaved(false), 2500);
    } catch (err) {
      toast.error('Failed to save invoice sequence');
    }
    setInvoiceSeqSaving(false);
  };

  const saveInvoiceProfile = async () => {
    setInvoiceProfileSaving(true);
    try {
      const currentSettings = settings?.settings || {};
      await api.put('/companies/settings', {
        settings: { ...currentSettings, invoice_profile: invoiceProfile }
      });
      setInvoiceProfileSaved(true);
      setTimeout(() => setInvoiceProfileSaved(false), 2500);
    } catch (err) {
      toast.error('Failed to save invoice profile');
    }
    setInvoiceProfileSaving(false);
  };

  const saveOperationalSettings = async () => {
    setOpSaving(true);
    setOpSaved(false);
    try {
      // Merge with existing settings to not overwrite email_config
      const currentRes = await api.get('/companies/settings');
      const existingSettings = currentRes.data.data.settings || {};
      const merged = { ...existingSettings, operational: opSettings };
      await api.put('/companies/settings', { settings: merged });
      setOpSaved(true);
      setTimeout(() => setOpSaved(false), 3000);
    } catch (err) {
      toast.info('Failed to save operational settings');
    }
    setOpSaving(false);
  };

  const handleSave = async () => {
    setSaving(true);
    setSaved(false);
    setError('');
    try {
      await api.put('/companies/settings', {
        currency: settings.currency,
        currency_symbol: settings.currency_symbol,
        currency_locale: settings.currency_locale,
        language: settings.language,
        timezone: settings.timezone,
        name: settings.name,
        email: settings.email,
        phone: settings.phone,
        address: settings.address,
        city: settings.city,
        state: settings.state,
        zip_code: settings.zip_code,
        country: settings.country,
        license_number: settings.license_number,
        insurance_expiry: settings.insurance_expiry || null
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      setError('Failed to save settings');
    }
    setSaving(false);
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) { toast.info('Please select an image file'); return; }
    if (file.size > 5 * 1024 * 1024) { toast.info('File must be under 5MB'); return; }
    
    const formData = new FormData();
    formData.append('logo', file);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch((process.env.REACT_APP_API_URL || 'https://api.safecorepest.com/api') + '/companies/logo', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + token },
        body: formData
      });
      const data = await res.json();
      if (data.success) {
        setSettings({ ...settings, logo_url: data.logo_url + '?t=' + Date.now() });
      } else { toast.error('Upload failed'); }
    } catch (err) { toast.error('Upload error: ' + err.message); }
  };

  const handleLogoRemove = async () => {
    setConfirmDialog({ message: 'Remove company logo?', confirmText: 'Remove', icon: '🖼', onConfirm: async () => {
      setConfirmDialog(null);
    try {
      await api.delete('/companies/logo');
      setSettings({ ...settings, logo_url: null });
    } catch (err) { toast.error('Error removing logo'); }
    }});
  };

  const fetchTaxCategories = async (country) => {
    setTaxCatLoading(true);
    try {
      const c = country || invoiceProfile.country || 'usa';
      const res = await api.get('/tax-categories?country=' + c);
      setTaxCategories(res.data.data || []);
    } catch(e) { console.error(e); }
    setTaxCatLoading(false);
  };

  const saveTaxCategoryRate = async (tc, newRate) => {
    try {
      const parsed = parseFloat(newRate);
      if (isNaN(parsed)) return;
      await api.put('/tax-categories/' + tc.id, { rate: parsed });
      setTaxCategories(prev => prev.map(t => t.id === tc.id ? { ...t, rate: parsed } : t));
      toast.success('Rate updated: ' + parsed + '%');
    } catch(e) {
      console.error('saveTaxCategoryRate error:', e.response?.data || e.message);
      toast.error('Error: ' + (e.response?.data?.message || e.message));
    }
  };

  const toggleTaxCategoryActive = async (tc) => {
    try {
      await api.put('/tax-categories/' + tc.id, { is_active: !tc.is_active });
      setTaxCategories(prev => prev.map(t => t.id === tc.id ? { ...t, is_active: !t.is_active } : t));
    } catch(e) { toast.error('Error updating category'); }
  };

  const addTaxCategory = async () => {
    if (!taxCatForm.code || !taxCatForm.name) { toast.info('Code and name required'); return; }
    setTaxCatSaving(true);
    try {
      await api.post('/tax-categories', { ...taxCatForm, rate: parseFloat(taxCatForm.rate||0) });
      setTaxCatAdding(false);
      setTaxCatForm({ country: invoiceProfile.country||'usa', code:'', name:'', description:'', rate:0, is_exempt:false, is_zero_rated:false });
      fetchTaxCategories(invoiceProfile.country);
      toast.success('Tax category added');
    } catch(e) { toast.error(e.response?.data?.message || 'Error'); }
    setTaxCatSaving(false);
  };

  const formatPreview = () => {
    if (!settings) return '';
    try {
      return new Intl.NumberFormat(settings.currency_locale, {
        style: 'currency', currency: settings.currency
      }).format(1234.56);
    } catch { return settings.currency_symbol + '1,234.56'; }
  };

  if (loading) return <Layout><div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>Loading settings...</div></Layout>;

  return (
    <Layout>
      <div style={{ maxWidth: '800px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <div>
            <h1 style={{ margin: 0, color: '#1A3A2A', fontSize: '24px' }}>Settings</h1>
            <p style={{ margin: '4px 0 0', color: '#666', fontSize: '14px' }}>System configuration for {settings?.name}</p>
          </div>
          <button onClick={handleSave} disabled={saving} style={{
            padding: '10px 24px', backgroundColor: saving ? '#9E9E9E' : saved ? '#4CAF50' : '#2D5C3F',
            color: 'white', border: 'none', borderRadius: '6px', cursor: saving ? 'default' : 'pointer',
            fontWeight: '600', fontSize: '14px', transition: 'all 0.2s'
          }}>
            {saving ? 'Saving...' : saved ? 'Saved!' : 'Save Changes'}
          </button>
        </div>

        {error && <div style={{ padding: '12px', backgroundColor: '#FFEBEE', color: '#C62828', borderRadius: '6px', marginBottom: '16px', fontSize: '14px' }}>{error}</div>}

        {/* CURRENCY SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>💰</span>
            <div>
              <h2 style={styles.cardTitle}>Currency</h2>
              <p style={styles.cardSubtitle}>Set the currency used across all proposals, invoices, and reports</p>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
              <label style={styles.label}>Currency</label>
              <select value={settings?.currency || 'USD'} onChange={e => handleCurrencyChange(e.target.value)} style={styles.input}>
                {CURRENCIES.map(c => (
                  <option key={c.code} value={c.code}>{c.symbol} - {c.name} ({c.code})</option>
                ))}
              </select>
            </div>
            <div>
              <label style={styles.label}>Preview</label>
              <div style={{
                padding: '10px 14px', backgroundColor: '#F0F7F4', borderRadius: '6px',
                border: '1px solid #C8E6C9', fontSize: '18px', fontWeight: '700', color: '#2D5C3F'
              }}>
                {formatPreview()}
              </div>
            </div>
          </div>
        </div>

        {/* TIMEZONE SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>🕐</span>
            <div>
              <h2 style={styles.cardTitle}>Timezone</h2>
              <p style={styles.cardSubtitle}>Used for scheduling, reports, and timestamps</p>
            </div>
          </div>
          <div>
            <label style={styles.label}>Timezone</label>
            <select value={settings?.timezone || 'America/New_York'} onChange={e => setSettings({...settings, timezone: e.target.value})} style={styles.input}>
              {TIMEZONES.map(tz => <option key={tz} value={tz}>{tz.replace(/_/g, ' ')}</option>)}
            </select>
          </div>
        </div>

        {/* LANGUAGE SECTION - Coming Soon */}
        <div style={{...styles.card, opacity: 0.6}}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>🌐</span>
            <div>
              <h2 style={styles.cardTitle}>Language <span style={{ fontSize: '11px', padding: '2px 8px', backgroundColor: '#FFF3E0', color: '#E65100', borderRadius: '10px', marginLeft: '8px' }}>Coming Soon</span></h2>
              <p style={styles.cardSubtitle}>System language for the interface</p>
            </div>
          </div>
          <div>
            <label style={styles.label}>Language</label>
            <select disabled style={{...styles.input, cursor: 'not-allowed', backgroundColor: '#F5F5F5'}}>
              <option>English</option>
            </select>
          </div>
        </div>

        {/* COMPANY INFO SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>🏢</span>
            <div>
              <h2 style={styles.cardTitle}>Company Information</h2>
              <p style={styles.cardSubtitle}>Displayed on proposals, invoices, and reports</p>
            </div>
          </div>

          {/* LOGO UPLOAD */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '20px', padding: '16px', backgroundColor: '#FAFAFA', borderRadius: '8px', border: '1px dashed #DDD' }}>
            <div style={{ width: '120px', height: '120px', borderRadius: '8px', border: '2px solid #E0E0E0', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', flexShrink: 0 }}>
              {settings?.logo_url ? (
                <img src={settings.logo_url} alt="Logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
              ) : (
                <div style={{ textAlign: 'center', color: '#BBB' }}>
                  <div style={{ fontSize: '32px' }}>🏢</div>
                  <div style={{ fontSize: '11px', marginTop: '4px' }}>No Logo</div>
                </div>
              )}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '4px' }}>Company Logo</div>
              <div style={{ fontSize: '12px', color: '#888', marginBottom: '12px' }}>Used on proposals, invoices, reports, and emails. PNG or JPG, max 5MB.</div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <label style={{ padding: '8px 16px', backgroundColor: '#2D5C3F', color: 'white', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                  {settings?.logo_url ? 'Change Logo' : 'Upload Logo'}
                  <input type="file" accept="image/*" onChange={handleLogoUpload} style={{ display: 'none' }} />
                </label>
                {settings?.logo_url && (
                  <button onClick={handleLogoRemove} style={{ padding: '8px 16px', backgroundColor: '#FFEBEE', color: '#C62828', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
                    Remove
                  </button>
                )}
              </div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <div>
              <label style={styles.label}>Company Name</label>
              <input value={settings?.name || ''} onChange={e => { setSettings({...settings, name: e.target.value}); setSaved(false); }} style={styles.input} />
            </div>
            <div>
              <label style={styles.label}>Website</label>
              <input value={settings?.settings?.website || ''} onChange={e => { setSettings({...settings, settings: {...(settings?.settings || {}), website: e.target.value}}); setSaved(false); }} style={styles.input} placeholder="www.yourcompany.com" />
            </div>
            <div>
              <label style={styles.label}>Email</label>
              <input value={settings?.email || ''} onChange={e => { setSettings({...settings, email: e.target.value}); setSaved(false); }} style={styles.input} type="email" />
            </div>
            <div>
              <label style={styles.label}>Phone</label>
              <input value={settings?.phone || ''} onChange={e => { setSettings({...settings, phone: e.target.value}); setSaved(false); }} style={styles.input} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={styles.label}>Address</label>
              <input value={settings?.address || ''} onChange={e => { setSettings({...settings, address: e.target.value}); setSaved(false); }} style={styles.input} placeholder="Street address" />
            </div>
            <div>
              <label style={styles.label}>City</label>
              <input value={settings?.city || ''} onChange={e => { setSettings({...settings, city: e.target.value}); setSaved(false); }} style={styles.input} />
            </div>
            <div>
              <label style={styles.label}>State</label>
              <input value={settings?.state || ''} onChange={e => { setSettings({...settings, state: e.target.value}); setSaved(false); }} style={styles.input} />
            </div>
            <div>
              <label style={styles.label}>ZIP Code</label>
              <input value={settings?.zip_code || ''} onChange={e => { setSettings({...settings, zip_code: e.target.value}); setSaved(false); }} style={styles.input} />
            </div>
            <div>
              <label style={styles.label}>Country</label>
              <input value={settings?.country || ''} onChange={e => { setSettings({...settings, country: e.target.value}); setSaved(false); }} style={styles.input} />
            </div>
          </div>
        </div>

        {/* LICENSES SECTION */}
        <div style={styles.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
            <div style={styles.cardHeader}>
              <span style={{ fontSize: '20px' }}>📜</span>
              <div>
                <h2 style={styles.cardTitle}>State Licenses</h2>
                <p style={styles.cardSubtitle}>Pest control licenses per state. The correct license will appear on proposals and reports based on the facility state.</p>
              </div>
            </div>
            <button onClick={() => { setEditingLicense(null); setLicenseForm({ state: '', license_number: '', license_type: 'Pest Control', expiry_date: '', issued_by: '' }); setShowLicenseModal(true); }} style={{
              padding: '8px 16px', backgroundColor: '#2D5C3F', color: 'white', border: 'none',
              borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap'
            }}>+ Add License</button>
          </div>

          {licenses.length === 0 ? (
            <div style={{ padding: '30px', textAlign: 'center', color: '#999', backgroundColor: '#FAFAFA', borderRadius: '8px', border: '1px dashed #DDD' }}>
              <div style={{ fontSize: '28px', marginBottom: '8px' }}>📜</div>
              <div style={{ fontSize: '14px', fontWeight: '500' }}>No licenses registered</div>
              <div style={{ fontSize: '12px', marginTop: '4px' }}>Add your pest control licenses for each state you operate in</div>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#F8F8F8' }}>
                  {['State', 'License #', 'Type', 'Expiry', 'Issued By', 'Actions'].map(h => (
                    <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#888', borderBottom: '2px solid #E0E0E0', textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {licenses.map(lic => {
                  const expiryDays = lic.expiry_date ? Math.floor((new Date(lic.expiry_date+'T00:00:00') - new Date()) / (1000*60*60*24)) : null;
                  const isExpired = expiryDays !== null && expiryDays < 0;
                  const isExpiringSoon = expiryDays !== null && !isExpired && expiryDays <= 60;
                  return (
                    <tr key={lic.id} style={{ borderBottom: '1px solid #F0F0F0' }}>
                      <td style={{ padding: '10px 12px', fontWeight: '600', fontSize: '13px' }}>
                        <span style={{ backgroundColor: '#E8F5E9', padding: '2px 8px', borderRadius: '4px', fontSize: '12px' }}>{lic.state}</span>
                        <span style={{ marginLeft: '6px', fontSize: '12px', color: '#888' }}>{STATE_NAMES[lic.state] || ''}</span>
                      </td>
                      <td style={{ padding: '10px 12px', fontSize: '13px', fontWeight: '500' }}>{lic.license_number}</td>
                      <td style={{ padding: '10px 12px', fontSize: '12px', color: '#666' }}>{lic.license_type}</td>
                      <td style={{ padding: '10px 12px', fontSize: '12px' }}>
                        {lic.expiry_date ? (() => {
                          const d = Math.floor((new Date(lic.expiry_date+'T00:00:00') - new Date()) / (1000*60*60*24));
                          const color = d < 0 ? '#DC2626' : d <= 30 ? '#DC2626' : d <= 60 ? '#D97706' : '#2E7D32';
                          const bg = d < 0 ? '#FEE2E2' : d <= 30 ? '#FEE2E2' : d <= 60 ? '#FEF3C7' : '#E8F5E9';
                          const icon = d < 0 ? '🔴 EXPIRED' : d <= 30 ? `🔴 ${d}d left` : d <= 60 ? `🟡 ${d}d left` : `✅ ${d}d left`;
                          return <span style={{ fontSize:'12px', fontWeight:'600', color, backgroundColor:bg, padding:'3px 8px', borderRadius:'8px' }}>
                            {new Date(lic.expiry_date+'T00:00:00').toLocaleDateString()} — {icon}
                          </span>;
                        })() : <span style={{ color:'#999' }}>—</span>}
                      </td>
                      <td style={{ padding: '10px 12px', fontSize: '12px', color: '#666' }}>{lic.issued_by || '--'}</td>
                      <td style={{ padding: '10px 12px' }}>
                        <button onClick={() => handleLicenseEdit(lic)} style={{ padding: '4px 10px', backgroundColor: '#E3F2FD', color: '#1565C0', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', marginRight: '4px' }}>Edit</button>
                        <button onClick={() => handleLicenseDelete(lic.id)} style={{ padding: '4px 10px', backgroundColor: '#FFEBEE', color: '#C62828', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>Delete</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {/* LICENSE MODAL */}
        {showLicenseModal && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
            <div style={{ backgroundColor: 'white', borderRadius: '12px', width: '500px', padding: '24px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2 style={{ margin: 0, fontSize: '18px', color: '#1A3A2A' }}>{editingLicense ? 'Edit License' : 'Add State License'}</h2>
                <button onClick={() => setShowLicenseModal(false)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#999' }}>x</button>
              </div>
              <div style={{ display: 'grid', gap: '12px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={styles.label}>State *</label>
                    <select value={licenseForm.state} onChange={e => setLicenseForm({...licenseForm, state: e.target.value})} style={styles.input}>
                      <option value="">Select State</option>
                      {US_STATES.map(s => <option key={s} value={s}>{s} - {STATE_NAMES[s]}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={styles.label}>License Number *</label>
                    <input value={licenseForm.license_number} onChange={e => setLicenseForm({...licenseForm, license_number: e.target.value})} style={styles.input} placeholder="e.g. 90722A" />
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={styles.label}>License Type</label>
                    <select value={licenseForm.license_type} onChange={e => setLicenseForm({...licenseForm, license_type: e.target.value})} style={styles.input}>
                      {['Pest Control', 'Termite Control', 'Fumigation', 'Wildlife Control', 'General Pest & Termite', 'Commercial Applicator', 'Structural Pest Control'].map(t => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label style={styles.label}>Expiry Date</label>
                    <input value={licenseForm.expiry_date} onChange={e => setLicenseForm({...licenseForm, expiry_date: e.target.value})} style={styles.input} type="date" />
                  </div>
                </div>
                <div>
                  <label style={styles.label}>Issued By</label>
                  <input value={licenseForm.issued_by} onChange={e => setLicenseForm({...licenseForm, issued_by: e.target.value})} style={styles.input} placeholder="e.g. NJ DEP, NY DEC" />
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                <button onClick={() => setShowLicenseModal(false)} style={{ padding: '10px 20px', backgroundColor: '#E0E0E0', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Cancel</button>
                <button onClick={handleLicenseSave} style={{ padding: '10px 24px', backgroundColor: '#2D5C3F', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}>{editingLicense ? 'Update' : 'Add License'}</button>
              </div>
            </div>
          </div>
        )}


        {/* GEOLOCATION REQUIREMENTS SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>📍</span>
            <div>
              <h2 style={styles.cardTitle}>Geolocation Requirements</h2>
              <p style={styles.cardSubtitle}>Define who must be within range of the facility to start or complete a Work Order.</p>
            </div>
          </div>

          {/* Radio configurado */}
          <div style={{ marginBottom: '20px' }}>
            <label style={styles.label}>Maximum Distance to Start/Complete a WO</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <input
                type="number" min="50" max="5000" step="50"
                value={opSettings.geo.radius_meters}
                onChange={e => setOpSettings(prev => ({ ...prev, geo: { ...prev.geo, radius_meters: parseInt(e.target.value) || 500 } }))}
                style={{ ...styles.input, width: '140px' }}
              />
              <span style={{ fontSize: '14px', color: '#555' }}>meters</span>
              <span style={{ fontSize: '12px', color: '#888', marginLeft: '4px' }}>
                ≈ {(opSettings.geo.radius_meters / 1000).toFixed(2)} km
              </span>
            </div>
          </div>

          {/* Toggles por rol */}
          <div style={{ borderTop: '1px solid #F0F0F0', paddingTop: '16px' }}>
            <p style={{ fontSize: '13px', color: '#555', marginBottom: '12px', fontWeight: '600' }}>
              Roles required to be within range:
            </p>
            {[
              { key: 'required_technician', label: 'Technician',  defaultNote: 'Required by default' },
              { key: 'required_supervisor', label: 'Supervisor',  defaultNote: 'Not required by default' },
              { key: 'required_manager',    label: 'Manager',     defaultNote: 'Not required by default' },
              { key: 'required_admin',      label: 'Admin',       defaultNote: 'Not required by default' },
            ].map(({ key, label, defaultNote }) => (
              <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '12px 16px', borderRadius: '8px', marginBottom: '8px',
                background: opSettings.geo[key] ? '#F0F7F4' : '#FAFAFA',
                border: `1px solid ${opSettings.geo[key] ? '#2D5C3F33' : '#E8E8E8'}` }}>
                <div>
                  <div style={{ fontWeight: '600', fontSize: '14px', color: '#1A3A2A' }}>{label}</div>
                  <div style={{ fontSize: '12px', color: '#888' }}>{defaultNote}</div>
                </div>
                <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px', cursor: 'pointer' }}>
                  <input type="checkbox" checked={opSettings.geo[key]}
                    onChange={e => setOpSettings(prev => ({ ...prev, geo: { ...prev.geo, [key]: e.target.checked } }))}
                    style={{ opacity: 0, width: 0, height: 0 }} />
                  <span style={{
                    position: 'absolute', cursor: 'pointer', inset: 0, borderRadius: '24px',
                    backgroundColor: opSettings.geo[key] ? '#2D5C3F' : '#CBD5E1',
                    transition: '0.3s'
                  }}></span>
                  <span style={{
                    position: 'absolute', content: '', height: '18px', width: '18px', left: opSettings.geo[key] ? '23px' : '3px',
                    bottom: '3px', backgroundColor: 'white', borderRadius: '50%',
                    transition: '0.3s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                  }}></span>
                </label>
              </div>
            ))}
          </div>

          <div style={{ marginTop: '16px' }}>
            <button onClick={saveOperationalSettings} disabled={opSaving}
              style={{ padding: '10px 24px', background: opSaved ? '#4CAF50' : '#2D5C3F', color: 'white',
                border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
              {opSaving ? 'Saving...' : opSaved ? '✓ Saved!' : 'Save Geolocation Settings'}
            </button>
          </div>
        </div>

        {/* DEVICE SCAN REQUIREMENTS SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>📷</span>
            <div>
              <h2 style={styles.cardTitle}>Device Scan Requirements</h2>
              <p style={styles.cardSubtitle}>Define who must scan a QR/barcode to access a device during inspection. Others can tap directly.</p>
            </div>
          </div>

          <div style={{ borderRadius: '8px', padding: '12px 16px', background: '#FFF8E7',
            border: '1px solid #D4AF3744', marginBottom: '16px' }}>
            <p style={{ fontSize: '13px', color: '#7A5F00', margin: 0 }}>
              <strong>ℹ️ How it works:</strong> When enabled for a role, the user must physically scan the device barcode/QR code to open the inspection. When disabled, they can tap the device directly.
            </p>
          </div>

          {[
            { key: 'required_technician', label: 'Technician',  defaultNote: 'Must scan by default' },
            { key: 'required_supervisor', label: 'Supervisor',  defaultNote: 'Can tap directly by default' },
            { key: 'required_manager',    label: 'Manager',     defaultNote: 'Can tap directly by default' },
            { key: 'required_admin',      label: 'Admin',       defaultNote: 'Can tap directly by default' },
          ].map(({ key, label, defaultNote }) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 16px', borderRadius: '8px', marginBottom: '8px',
              background: opSettings.scan[key] ? '#F0F7F4' : '#FAFAFA',
              border: `1px solid ${opSettings.scan[key] ? '#2D5C3F33' : '#E8E8E8'}` }}>
              <div>
                <div style={{ fontWeight: '600', fontSize: '14px', color: '#1A3A2A' }}>{label}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>{defaultNote}</div>
              </div>
              <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px', cursor: 'pointer' }}>
                <input type="checkbox" checked={opSettings.scan[key]}
                  onChange={e => setOpSettings(prev => ({ ...prev, scan: { ...prev.scan, [key]: e.target.checked } }))}
                  style={{ opacity: 0, width: 0, height: 0 }} />
                <span style={{
                  position: 'absolute', cursor: 'pointer', inset: 0, borderRadius: '24px',
                  backgroundColor: opSettings.scan[key] ? '#2D5C3F' : '#CBD5E1',
                  transition: '0.3s'
                }}></span>
                <span style={{
                  position: 'absolute', content: '', height: '18px', width: '18px', left: opSettings.scan[key] ? '23px' : '3px',
                  bottom: '3px', backgroundColor: 'white', borderRadius: '50%',
                  transition: '0.3s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                }}></span>
              </label>
            </div>
          ))}

          <div style={{ marginTop: '16px' }}>
            <button onClick={saveOperationalSettings} disabled={opSaving}
              style={{ padding: '10px 24px', background: opSaved ? '#4CAF50' : '#2D5C3F', color: 'white',
                border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
              {opSaving ? 'Saving...' : opSaved ? '✓ Saved!' : 'Save Scan Settings'}
            </button>
          </div>
        </div>


        {/* PRICING VISIBILITY SECTION (Sub-session C) */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>💰</span>
            <div>
              <h2 style={styles.cardTitle}>Pricing Visibility</h2>
              <p style={styles.cardSubtitle}>Choose which roles can see prices on work orders, line items, and the catalog. Admins always see prices.</p>
            </div>
          </div>

          <div style={{ borderRadius: '8px', padding: '12px 16px', background: '#FFF8E7',
            border: '1px solid #D4AF3744', marginBottom: '16px' }}>
            <p style={{ fontSize: '13px', color: '#7A5F00', margin: 0 }}>
              <strong>ℹ️ How it works:</strong> When OFF, the role still sees the work order, line items, and catalog entries — but the monetary fields (price, total, default price) are removed from the response. Admins and Super Admins always see prices regardless of these toggles.
            </p>
          </div>

          {[
            { key: 'csr',        label: 'Customer Service (CSR)', defaultNote: 'On by default — typically handles billing' },
            { key: 'manager',    label: 'Manager',                defaultNote: 'Off by default — operational role' },
            { key: 'supervisor', label: 'Supervisor',             defaultNote: 'Off by default — field oversight role' },
            { key: 'router',     label: 'Router',                 defaultNote: 'Off by default — schedules WOs' },
            { key: 'technician', label: 'Technician',             defaultNote: 'Off by default — performs the service' },
          ].map(({ key, label, defaultNote }) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 16px', borderRadius: '8px', marginBottom: '8px',
              background: pricingViz[key] ? '#F0F7F4' : '#FAFAFA',
              border: `1px solid ${pricingViz[key] ? '#2D5C3F33' : '#E8E8E8'}` }}>
              <div>
                <div style={{ fontWeight: '600', fontSize: '14px', color: '#1A3A2A' }}>{label}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>{defaultNote}</div>
              </div>
              <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px', cursor: 'pointer' }}>
                <input type="checkbox" checked={pricingViz[key]}
                  onChange={e => setPricingViz(prev => ({ ...prev, [key]: e.target.checked }))}
                  style={{ opacity: 0, width: 0, height: 0 }} />
                <span style={{
                  position: 'absolute', cursor: 'pointer', inset: 0, borderRadius: '24px',
                  backgroundColor: pricingViz[key] ? '#2D5C3F' : '#CBD5E1',
                  transition: '0.3s'
                }}></span>
                <span style={{
                  position: 'absolute', content: '', height: '18px', width: '18px', left: pricingViz[key] ? '23px' : '3px',
                  bottom: '3px', backgroundColor: 'white', borderRadius: '50%',
                  transition: '0.3s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                }}></span>
              </label>
            </div>
          ))}

          <div style={{ marginTop: '16px' }}>
            <button onClick={savePricingVisibility} disabled={pricingSaving}
              style={{ padding: '10px 24px', background: pricingSaved ? '#4CAF50' : '#2D5C3F', color: 'white',
                border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
              {pricingSaving ? 'Saving...' : pricingSaved ? '✓ Saved!' : 'Save Pricing Visibility'}
            </button>
          </div>
        </div>

        {/* REPORT EMAIL PERMISSIONS SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>✉️</span>
            <div>
              <h2 style={styles.cardTitle}>Report Email Permissions</h2>
              <p style={styles.cardSubtitle}>Control what technicians can do with report email recipients on a Work Order.</p>
            </div>
          </div>

          <div style={{ borderRadius: '8px', padding: '12px 16px', background: '#FFF8E7',
            border: '1px solid #D4AF3744', marginBottom: '16px' }}>
            <p style={{ fontSize: '13px', color: '#7A5F00', margin: 0 }}>
              <strong>ℹ️ How it works:</strong> Admins and managers always have full control.
              These settings only restrict <strong>technicians and supervisors</strong> in the mobile app.
            </p>
          </div>

          {[
            {
              key: 'allow_add',
              label: 'Allow adding new recipients',
              defaultNote: 'Enabled by default — technicians can add emails',
              section: 'report_emails'
            },
            {
              key: 'allow_edit_delete',
              label: 'Allow editing & deleting recipients',
              defaultNote: 'Disabled by default — only admins/managers can modify',
              section: 'report_emails'
            },
          ].map(({ key, label, defaultNote, section }) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '12px 16px', borderRadius: '8px', marginBottom: '8px',
              background: opSettings[section][key] ? '#F0F7F4' : '#FAFAFA',
              border: `1px solid ${opSettings[section][key] ? '#2D5C3F33' : '#E8E8E8'}` }}>
              <div>
                <div style={{ fontWeight: '600', fontSize: '14px', color: '#1A3A2A' }}>{label}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>{defaultNote}</div>
              </div>
              <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px', cursor: 'pointer' }}>
                <input type="checkbox" checked={opSettings[section][key]}
                  onChange={e => setOpSettings(prev => ({ ...prev, [section]: { ...prev[section], [key]: e.target.checked } }))}
                  style={{ opacity: 0, width: 0, height: 0 }} />
                <span style={{
                  position: 'absolute', cursor: 'pointer', inset: 0, borderRadius: '24px',
                  backgroundColor: opSettings[section][key] ? '#2D5C3F' : '#CBD5E1',
                  transition: '0.3s'
                }}></span>
                <span style={{
                  position: 'absolute', content: '', height: '18px', width: '18px',
                  left: opSettings[section][key] ? '23px' : '3px',
                  bottom: '3px', backgroundColor: 'white', borderRadius: '50%',
                  transition: '0.3s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                }}></span>
              </label>
            </div>
          ))}

          <div style={{ marginTop: '16px' }}>
            <button onClick={saveOperationalSettings} disabled={opSaving}
              style={{ padding: '10px 24px', background: opSaved ? '#4CAF50' : '#2D5C3F', color: 'white',
                border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
              {opSaving ? 'Saving...' : opSaved ? '✓ Saved!' : 'Save Email Permissions'}
            </button>
          </div>
        </div>

        {/* EMAIL CONFIGURATION SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>📧</span>
            <div>
              <h2 style={styles.cardTitle}>Email Configuration</h2>
              <p style={styles.cardSubtitle}>Configure sender information for each type of email. Use emails that exist in your domain.</p>
            </div>
          </div>

          {/* Display Name */}
          <div style={{ marginBottom: '20px', padding: '16px', background: '#F0F7F4', borderRadius: '8px' }}>
            <label style={styles.label}>Company Display Name (used in all emails)</label>
            <input value={emailSettings.display_name} onChange={e => setEmailSettings({...emailSettings, display_name: e.target.value})}
              style={styles.input} placeholder="e.g. Victory Pest Solutions" />
          </div>

          {/* Email types table */}
          {[
            { key: 'proposals',     label: '📄 Proposals',         desc: 'Sent when a proposal is emailed to a client' },
            { key: 'reports',       label: '📊 Service Reports',   desc: 'Sent when a service report is completed' },
            { key: 'invoices',      label: '💰 Invoices',          desc: 'Sent when an invoice is generated' },
            { key: 'notifications', label: '🔔 Notifications',     desc: 'System alerts and reminders' },
          ].map(({ key, label, desc }) => (
            <div key={key} style={{ marginBottom: '16px', border: '1px solid #E8E8E8', borderRadius: '8px', overflow: 'hidden' }}>
              <div style={{ background: '#F8F9FA', padding: '10px 16px', borderBottom: '1px solid #E8E8E8' }}>
                <div style={{ fontWeight: '700', fontSize: '14px', color: '#1A3A2A' }}>{label}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>{desc}</div>
              </div>
              <div style={{ padding: '16px', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={styles.label}>From Name</label>
                  <input value={emailSettings[key]?.from_name || ''} onChange={e => updateEmailType(key, 'from_name', e.target.value)}
                    style={styles.input} placeholder={emailSettings.display_name || 'Company Name'} />
                </div>
                <div>
                  <label style={styles.label}>From Email</label>
                  <input value={emailSettings[key]?.from_email || ''} onChange={e => updateEmailType(key, 'from_email', e.target.value)}
                    style={styles.input} placeholder="info@yourcompany.com" type="email" />
                </div>
                <div>
                  <label style={styles.label}>Reply-to</label>
                  <select value={emailSettings[key]?.reply_to === 'no-reply' ? 'no-reply' : 'custom'}
                    onChange={e => updateEmailType(key, 'reply_to', e.target.value === 'no-reply' ? 'no-reply' : emailSettings[key]?.from_email || '')}
                    style={{ ...styles.input, marginBottom: '6px' }}>
                    <option value="custom">Custom email</option>
                    <option value="no-reply">No Reply</option>
                  </select>
                  {emailSettings[key]?.reply_to !== 'no-reply' && (
                    <input value={emailSettings[key]?.reply_to || ''} onChange={e => updateEmailType(key, 'reply_to', e.target.value)}
                      style={styles.input} placeholder="reply@yourcompany.com" type="email" />
                  )}
                </div>
              </div>
            </div>
          ))}

          <div style={{ display: 'flex', gap: '10px', marginTop: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
            <button onClick={saveEmailSettings} disabled={emailSaving}
              style={{ padding: '10px 24px', background: emailSaved ? '#4CAF50' : '#2D5C3F', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px' }}>
              {emailSaving ? 'Saving...' : emailSaved ? '✓ Saved!' : 'Save Email Settings'}
            </button>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <input value={testEmailAddress} onChange={e => setTestEmailAddress(e.target.value)}
                placeholder="Enter email to test..." type="email"
                style={{ padding: '10px 12px', border: '1px solid #DDD', borderRadius: '6px', fontSize: '14px', width: '220px' }} />
              <button onClick={sendTestEmail} disabled={testEmailSending}
                style={{ padding: '10px 20px', background: 'white', color: '#2D5C3F', border: '1px solid #2D5C3F', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px', whiteSpace: 'nowrap' }}>
                {testEmailSending ? 'Sending...' : '✉️ Send Test'}
              </button>
            </div>
          </div>
        </div>

        {/* SERVICE REPORT DELIVERY SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>📤</span>
            <div>
              <h2 style={styles.cardTitle}>Service Report Delivery</h2>
              <p style={styles.cardSubtitle}>Control how service reports are delivered to clients after a Work Order is completed.</p>
            </div>
          </div>

          {/* Mode selector */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '24px' }}>
            {[
              {
                value: 'auto_send',
                icon: '⚡',
                title: 'Auto-Send',
                desc: 'Report is generated and sent to the client immediately when the technician completes the Work Order.'
              },
              {
                value: 'review_queue',
                icon: '🔍',
                title: 'Review Queue',
                desc: 'Report is held for review. A supervisor/manager must approve and release it before the client receives it.'
              }
            ].map(opt => (
              <div key={opt.value}
                onClick={() => setReportDelivery(prev => ({ ...prev, mode: opt.value }))}
                style={{
                  border: `2px solid ${reportDelivery.mode === opt.value ? '#2D5C3F' : '#E8E8E8'}`,
                  borderRadius: '10px', padding: '16px', cursor: 'pointer',
                  background: reportDelivery.mode === opt.value ? '#F0F7F4' : 'white',
                  transition: 'all 0.2s'
                }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <span style={{ fontSize: '22px' }}>{opt.icon}</span>
                  <span style={{ fontWeight: '700', fontSize: '15px', color: '#1A3A2A' }}>{opt.title}</span>
                  {reportDelivery.mode === opt.value && (
                    <span style={{ marginLeft: 'auto', background: '#2D5C3F', color: 'white',
                      fontSize: '11px', padding: '2px 8px', borderRadius: '10px', fontWeight: '600' }}>
                      Active
                    </span>
                  )}
                </div>
                <p style={{ fontSize: '13px', color: '#555', margin: 0, lineHeight: '1.5' }}>{opt.desc}</p>
              </div>
            ))}
          </div>

          {/* Reviewers — solo visible en review_queue mode */}
          {reportDelivery.mode === 'review_queue' && (
            <div style={{ borderTop: '1px solid #F0F0F0', paddingTop: '16px' }}>
              <p style={{ fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '12px' }}>
                Who can review and release reports:
              </p>
              {[
                { key: 'supervisor', label: 'Supervisor', note: 'Direct supervisor of the technician' },
                { key: 'manager',    label: 'Manager',    note: 'Company managers' },
                { key: 'admin',      label: 'Admin',      note: 'Company administrators' },
              ].map(({ key, label, note }) => (
                <div key={key} style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '12px 16px', borderRadius: '8px', marginBottom: '8px',
                  background: reportDelivery.reviewers[key] ? '#F0F7F4' : '#FAFAFA',
                  border: `1px solid ${reportDelivery.reviewers[key] ? '#2D5C3F33' : '#E8E8E8'}`
                }}>
                  <div>
                    <div style={{ fontWeight: '600', fontSize: '14px', color: '#1A3A2A' }}>{label}</div>
                    <div style={{ fontSize: '12px', color: '#888' }}>{note}</div>
                  </div>
                  <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px', cursor: 'pointer' }}>
                    <input type="checkbox" checked={reportDelivery.reviewers[key]}
                      onChange={e => setReportDelivery(prev => ({
                        ...prev, reviewers: { ...prev.reviewers, [key]: e.target.checked }
                      }))}
                      style={{ opacity: 0, width: 0, height: 0 }} />
                    <span style={{
                      position: 'absolute', cursor: 'pointer', inset: 0, borderRadius: '24px',
                      backgroundColor: reportDelivery.reviewers[key] ? '#2D5C3F' : '#CBD5E1',
                      transition: '0.3s'
                    }}></span>
                    <span style={{
                      position: 'absolute', height: '18px', width: '18px',
                      left: reportDelivery.reviewers[key] ? '23px' : '3px', bottom: '3px',
                      backgroundColor: 'white', borderRadius: '50%', transition: '0.3s',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                    }}></span>
                  </label>
                </div>
              ))}
              <div style={{ marginTop: '12px', padding: '12px 16px', background: '#FFF8E7',
                border: '1px solid #D4AF3744', borderRadius: '8px' }}>
                <p style={{ fontSize: '13px', color: '#7A5F00', margin: 0 }}>
                  <strong>ℹ️ Notification:</strong> When a WO is completed, reviewers will be notified instantly via the system and by email.
                </p>
              </div>

              {/* ── Schedule & Window Settings ── */}
              <div style={{ marginTop: '20px', borderTop: '1px solid #F0F0F0', paddingTop: '16px' }}>
                <p style={{ fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '14px' }}>
                  📅 Review Schedule & Auto-Release
                </p>

                {/* Digest time + Auto-release time */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '14px' }}>
                  <div>
                    <label style={{ fontSize: '12px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '6px' }}>
                      Daily Digest Email Time
                    </label>
                    <input type="time" value={reportDelivery.digest_time}
                      onChange={e => setReportDelivery(prev => ({ ...prev, digest_time: e.target.value }))}
                      style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }} />
                    <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>Email sent to reviewers with pending reports</div>
                  </div>
                  <div>
                    <label style={{ fontSize: '12px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '6px' }}>
                      Auto-Release Time
                    </label>
                    <input type="time" value={reportDelivery.auto_release_time}
                      onChange={e => setReportDelivery(prev => ({ ...prev, auto_release_time: e.target.value }))}
                      style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }} />
                    <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>Unreviewed reports sent automatically</div>
                  </div>
                </div>

                {/* Review window days + Skip weekends */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                  <div>
                    <label style={{ fontSize: '12px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '6px' }}>
                      Review Window
                    </label>
                    <select value={reportDelivery.review_window_days}
                      onChange={e => setReportDelivery(prev => ({ ...prev, review_window_days: parseInt(e.target.value) }))}
                      style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                      <option value={1}>1 day</option>
                      <option value={2}>2 days</option>
                      <option value={3}>3 days</option>
                      <option value={5}>5 days</option>
                      <option value={7}>7 days</option>
                    </select>
                    <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>How long before auto-release triggers</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '14px', paddingTop: '20px' }}>
                    <label style={{ position: 'relative', display: 'inline-block', width: '44px', height: '24px', cursor: 'pointer', flexShrink: 0 }}>
                      <input type="checkbox" checked={reportDelivery.skip_weekends}
                        onChange={e => setReportDelivery(prev => ({ ...prev, skip_weekends: e.target.checked }))}
                        style={{ opacity: 0, width: 0, height: 0 }} />
                      <span style={{ position: 'absolute', cursor: 'pointer', inset: 0, borderRadius: '24px',
                        backgroundColor: reportDelivery.skip_weekends ? '#2D5C3F' : '#CBD5E1', transition: '0.3s' }}></span>
                      <span style={{ position: 'absolute', height: '18px', width: '18px',
                        left: reportDelivery.skip_weekends ? '23px' : '3px', bottom: '3px',
                        backgroundColor: 'white', borderRadius: '50%', transition: '0.3s',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.3)' }}></span>
                    </label>
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: '#1A3A2A' }}>Skip Weekends</div>
                      <div style={{ fontSize: '11px', color: '#888' }}>Count only business days for review window</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div style={{ marginTop: '20px' }}>
            <button onClick={saveReportDelivery} disabled={rdSaving}
              style={{ padding: '10px 24px', background: rdSaved ? '#4CAF50' : '#2D5C3F',
                color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer',
                fontWeight: '600', fontSize: '14px' }}>
              {rdSaving ? 'Saving...' : rdSaved ? '✓ Saved!' : 'Save Report Delivery Settings'}
            </button>
          </div>
        </div>

      </div>
      {confirmDialog && (
        <ConfirmDialog
          message={confirmDialog.message}
          confirmText={confirmDialog.confirmText}
          confirmColor={confirmDialog.confirmColor || '#DC2626'}
          icon={confirmDialog.icon || '⚠'}
          onConfirm={confirmDialog.onConfirm}
          onCancel={() => setConfirmDialog(null)}
        />
      )}

        {/* INVOICE NUMBERING SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>🔢</span>
            <div>
              <h2 style={styles.cardTitle}>Invoice Numbering</h2>
              <p style={styles.cardSubtitle}>Configure invoice number format and starting sequence. Use this when migrating from another system.</p>
            </div>
          </div>

          <div style={{ borderRadius: '8px', padding: '12px 16px', background: '#FFF8E7',
            border: '1px solid #D4AF3744', marginBottom: '16px' }}>
            <p style={{ fontSize: '13px', color: '#7A5F00', margin: 0 }}>
              <strong>⚠️ Important:</strong> Changing the next number will affect all future invoices.
              If you are migrating from another system, set this to your last invoice number + 1.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div>
              <label style={styles.label}>Invoice Prefix</label>
              <input style={styles.input} placeholder="INV-"
                value={invoiceSeq.prefix}
                onChange={e => setInvoiceSeq(p => ({ ...p, prefix: e.target.value }))} />
              <p style={{ fontSize: '11px', color: '#9CA3AF', margin: '4px 0 0' }}>e.g. INV-, FACT-, SC-</p>
            </div>
            <div>
              <label style={styles.label}>Next Invoice Number</label>
              <input type="number" min="1" style={styles.input} placeholder="1001"
                value={invoiceSeq.next_number}
                onChange={e => {
                  const val = e.target.value;
                  setInvoiceSeq(p => ({ ...p, next_number: val === '' ? '' : parseInt(val) || 1 }));
                }} />
            </div>
            <div>
              <label style={styles.label}>Number of Digits</label>
              <select style={styles.input} value={invoiceSeq.padding}
                onChange={e => setInvoiceSeq(p => ({ ...p, padding: parseInt(e.target.value) }))}>
                <option value={4}>4 digits — 0001</option>
                <option value={5}>5 digits — 00001</option>
                <option value={6}>6 digits — 000001</option>
                <option value={1}>No padding — 1</option>
              </select>
            </div>
          </div>
          <div style={{ padding: '12px 16px', background: '#F0F7F4', borderRadius: '8px',
            border: '1px solid #2D5C3F22', marginBottom: '8px' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#374151' }}>
              Preview: <strong style={{ color: '#2D5C3F', fontSize: '15px' }}>
                {(invoiceSeq.prefix || 'INV-') + String(invoiceSeq.next_number || 1).padStart(invoiceSeq.padding || 4, '0')}
              </strong>
            </p>
          </div>
          {/* Overflow warning */}
          {(invoiceSeq.next_number || 1) >= Math.pow(10, invoiceSeq.padding || 4) && (
            <div style={{ padding: '10px 14px', background: '#FFF8E7', borderRadius: '8px',
              border: '1px solid #D4AF3744', marginBottom: '16px' }}>
              <p style={{ margin: 0, fontSize: '12px', color: '#7A5F00' }}>
                ⚠️ <strong>Number exceeds digit limit.</strong> Invoice numbers will still be generated correctly
                but will have more digits than configured (e.g. {String(invoiceSeq.next_number || 1).length} digits instead of {invoiceSeq.padding || 4}).
                Consider increasing the digit count.
              </p>
            </div>
          )}

          <div style={{ marginTop: '8px' }}>
            <button onClick={saveInvoiceSeq} disabled={invoiceSeqSaving}
              style={{ padding: '10px 24px', background: invoiceSeqSaved ? '#4CAF50' : '#2D5C3F',
                color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer',
                fontWeight: '600', fontSize: '14px' }}>
              {invoiceSeqSaving ? 'Saving...' : invoiceSeqSaved ? '✓ Saved!' : 'Save Numbering'}
            </button>
          </div>
        </div>

        {/* INVOICE PROFILE SECTION */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize: '20px' }}>🧾</span>
            <div>
              <h2 style={styles.cardTitle}>Invoice Profile</h2>
              <p style={styles.cardSubtitle}>Configure your invoice template, company details and regional settings.</p>
            </div>
          </div>

          {/* Country / Template */}
          <div style={{ marginBottom: '20px' }}>
            <label style={styles.label}>Invoice Template</label>
            <div style={{ display: 'flex', gap: '12px' }}>
              {[
                { value: 'usa', label: '🇺🇸 USA', desc: 'Full header with company info' },
                { value: 'venezuela', label: '🇻🇪 Venezuela (Forma Libre)', desc: 'No header — prints on pre-printed forms' },
              ].map(opt => (
                <div key={opt.value} onClick={() => { setInvoiceProfile(p => ({ ...p, country: opt.value })); fetchTaxCategories(opt.value); }}
                  style={{ flex: 1, padding: '14px 16px', borderRadius: '8px', cursor: 'pointer',
                    border: `2px solid ${invoiceProfile.country === opt.value ? '#2D5C3F' : '#E8E8E8'}`,
                    background: invoiceProfile.country === opt.value ? '#F0F7F4' : '#FAFAFA' }}>
                  <div style={{ fontWeight: '700', fontSize: '14px', color: '#1A3A2A' }}>{opt.label}</div>
                  <div style={{ fontSize: '12px', color: '#888', marginTop: '3px' }}>{opt.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Company Info — only for USA */}
          {invoiceProfile.country === 'usa' && (
            <div style={{ marginBottom: '20px' }}>
              <p style={{ margin: '0 0 12px', fontSize: '13px', fontWeight: '700', color: '#2D5C3F', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Company Information</p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={styles.label}>Tagline</label>
                  <input style={styles.input} placeholder="Pest Management Services"
                    value={invoiceProfile.tagline} onChange={e => setInvoiceProfile(p => ({ ...p, tagline: e.target.value }))} />
                </div>
                <div>
                  <label style={styles.label}>EIN (optional)</label>
                  <input style={styles.input} placeholder="XX-XXXXXXX"
                    value={invoiceProfile.ein} onChange={e => setInvoiceProfile(p => ({ ...p, ein: e.target.value }))} />
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={styles.label}>Address</label>
                  <input style={styles.input} placeholder="123 Main St, Suite 100"
                    value={invoiceProfile.address} onChange={e => setInvoiceProfile(p => ({ ...p, address: e.target.value }))} />
                </div>
                <div>
                  <label style={styles.label}>City</label>
                  <input style={styles.input} placeholder="Union"
                    value={invoiceProfile.city} onChange={e => setInvoiceProfile(p => ({ ...p, city: e.target.value }))} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div>
                    <label style={styles.label}>State</label>
                    <input style={styles.input} placeholder="NJ"
                      value={invoiceProfile.state} onChange={e => setInvoiceProfile(p => ({ ...p, state: e.target.value }))} />
                  </div>
                  <div>
                    <label style={styles.label}>ZIP</label>
                    <input style={styles.input} placeholder="07083"
                      value={invoiceProfile.zip_code} onChange={e => setInvoiceProfile(p => ({ ...p, zip_code: e.target.value }))} />
                  </div>
                </div>
                <div>
                  <label style={styles.label}>Phone</label>
                  <input style={styles.input} placeholder="(908) 555-0100"
                    value={invoiceProfile.phone} onChange={e => setInvoiceProfile(p => ({ ...p, phone: e.target.value }))} />
                </div>
                <div>
                  <label style={styles.label}>Billing Email</label>
                  <input style={styles.input} placeholder="billing@company.com"
                    value={invoiceProfile.email} onChange={e => setInvoiceProfile(p => ({ ...p, email: e.target.value }))} />
                </div>
              </div>
            </div>
          )}

          {/* Venezuela top margin */}
          {invoiceProfile.country === 'venezuela' && (
            <div style={{ marginBottom: '20px' }}>
              <label style={styles.label}>Top Margin (cm) — Height of pre-printed header</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <input type="range" min="4" max="12" step="0.5"
                  value={invoiceProfile.top_margin_cm}
                  onChange={e => setInvoiceProfile(p => ({ ...p, top_margin_cm: parseFloat(e.target.value) }))}
                  style={{ flex: 1 }} />
                <span style={{ fontWeight: '700', color: '#2D5C3F', minWidth: '40px' }}>{invoiceProfile.top_margin_cm} cm</span>
              </div>
              <p style={{ fontSize: '12px', color: '#888', margin: '6px 0 0' }}>
                Adjust to match the height of your pre-printed fiscal form header so the content prints in the right position.
              </p>
            </div>
          )}

          {/* Payment & Legal */}
          <div style={{ marginBottom: '20px' }}>
            <p style={{ margin: '0 0 12px', fontSize: '13px', fontWeight: '700', color: '#2D5C3F', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Payment & Legal</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <label style={styles.label}>Payment Terms</label>
                <select style={styles.input} value={invoiceProfile.payment_terms}
                  onChange={e => setInvoiceProfile(p => ({ ...p, payment_terms: e.target.value }))}>
                  <option value="Net 15">Net 15</option>
                  <option value="Net 30">Net 30</option>
                  <option value="Net 45">Net 45</option>
                  <option value="Net 60">Net 60</option>
                  <option value="Due on Receipt">Due on Receipt</option>
                </select>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={styles.label}>Payment Instructions</label>
                <input style={styles.input} placeholder="e.g. Make checks payable to..."
                  value={invoiceProfile.payment_instructions}
                  onChange={e => setInvoiceProfile(p => ({ ...p, payment_instructions: e.target.value }))} />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={styles.label}>Legal Note / Footer</label>
                <input style={styles.input} placeholder="e.g. Thank you for your business."
                  value={invoiceProfile.legal_note}
                  onChange={e => setInvoiceProfile(p => ({ ...p, legal_note: e.target.value }))} />
              </div>
            </div>
          </div>

          <div style={{ marginTop: '8px' }}>
            <button onClick={saveInvoiceProfile} disabled={invoiceProfileSaving}
              style={{ padding: '10px 24px', background: invoiceProfileSaved ? '#4CAF50' : '#2D5C3F',
                color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer',
                fontWeight: '600', fontSize: '14px' }}>
              {invoiceProfileSaving ? 'Saving...' : invoiceProfileSaved ? '✓ Saved!' : 'Save Invoice Profile'}
            </button>
          </div>
        </div>

        {/* ── TAX CATEGORIES CARD ─────────────────────────────── */}
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={{ fontSize:'24px' }}>🧾</span>
            <div>
              <h2 style={styles.cardTitle}>Tax Categories</h2>
              <p style={styles.cardSubtitle}>Configure tax rates per line item category for your invoice country. System defaults can be customized per company.</p>
            </div>
          </div>
          {taxCatLoading
            ? <div style={{ color:'#9CA3AF', fontSize:'14px' }}>Loading...</div>
            : (
            <>
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'13px', marginBottom:'16px' }}>
                <thead>
                  <tr style={{ background:'#F3F4F6' }}>
                    {['Name','Description','Rate (%)','Exempt','Active'].map(h => (
                      <th key={h} style={{ padding:'8px 10px', textAlign:'left', fontWeight:700, color:'#374151', borderBottom:'1px solid #E5E7EB' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {taxCategories.map(tc => (
                    <tr key={tc.id} style={{ borderBottom:'1px solid #F3F4F6', opacity: tc.is_active ? 1 : 0.45 }}>
                      <td style={{ padding:'8px 10px', fontWeight:600, color:'#1A3A2A' }}>
                        {tc.name}
                        {!tc.company_id && <span style={{ marginLeft:'6px', fontSize:'10px', background:'#EFF6FF', color:'#2563EB', borderRadius:'4px', padding:'1px 5px' }}>system</span>}
                      </td>
                      <td style={{ padding:'8px 10px', color:'#6B7280', maxWidth:'220px' }}>{tc.description}</td>
                      <td style={{ padding:'8px 10px', width:'110px' }}>
                        {tc.is_exempt || tc.is_zero_rated
                          ? <span style={{ color:'#16A34A', fontWeight:700 }}>{tc.is_exempt ? 'Exempt' : '0% zero'}</span>
                          : <div style={{ display:'flex', alignItems:'center', gap:'4px' }}>
                              <input type="number" min="0" max="50" step="0.001"
                                value={tc.rate}
                                onChange={e => setTaxCategories(prev => prev.map(t => t.id === tc.id ? {...t, rate: e.target.value} : t))}
                                style={{ width:'60px', padding:'4px 6px', border:'1px solid #D1D5DB', borderRadius:'5px', fontSize:'13px' }} />
                              <button onClick={() => saveTaxCategoryRate(tc, tc.rate)}
                                style={{ padding:'3px 7px', background:'#2D5C3F', color:'white', border:'none', borderRadius:'4px', fontSize:'11px', cursor:'pointer', fontWeight:600 }}>
                                ✓
                              </button>
                            </div>
                        }
                      </td>
                      <td style={{ padding:'8px 10px', textAlign:'center' }}>{tc.is_exempt ? '✓' : tc.is_zero_rated ? '0%' : '—'}</td>
                      <td style={{ padding:'8px 10px', textAlign:'center' }}>
                        <input type="checkbox" checked={tc.is_active}
                          onChange={() => toggleTaxCategoryActive(tc)} style={{ cursor:'pointer' }} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {!taxCatAdding
                ? <button onClick={() => { setTaxCatAdding(true); setTaxCatForm(f => ({ ...f, country: invoiceProfile.country||'usa' })); }}
                    style={{ padding:'8px 16px', background:'#F0FDF4', color:'#16A34A', border:'1px solid #BBF7D0', borderRadius:'6px', fontSize:'13px', fontWeight:600, cursor:'pointer' }}>
                    + Add Custom Category
                  </button>
                : (
                  <div style={{ background:'#F9FAFB', border:'1px solid #E5E7EB', borderRadius:'8px', padding:'16px', marginTop:'8px' }}>
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'10px', marginBottom:'10px' }}>
                      <div>
                        <label style={styles.label}>Code *</label>
                        <input value={taxCatForm.code} onChange={e => setTaxCatForm(f=>({...f,code:e.target.value}))}
                          placeholder="e.g. my_service" style={styles.input} />
                      </div>
                      <div>
                        <label style={styles.label}>Name *</label>
                        <input value={taxCatForm.name} onChange={e => setTaxCatForm(f=>({...f,name:e.target.value}))}
                          placeholder="Display name" style={styles.input} />
                      </div>
                      <div>
                        <label style={styles.label}>Rate (%)</label>
                        <input type="number" min="0" max="50" step="0.5"
                          value={taxCatForm.rate} onChange={e => setTaxCatForm(f=>({...f,rate:e.target.value}))}
                          style={styles.input} />
                      </div>
                    </div>
                    <div style={{ marginBottom:'10px' }}>
                      <label style={styles.label}>Description</label>
                      <input value={taxCatForm.description} onChange={e => setTaxCatForm(f=>({...f,description:e.target.value}))}
                        placeholder="Optional description" style={styles.input} />
                    </div>
                    <div style={{ display:'flex', gap:'12px', marginBottom:'12px' }}>
                      <label style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'13px', cursor:'pointer' }}>
                        <input type="checkbox" checked={taxCatForm.is_exempt}
                          onChange={e => setTaxCatForm(f=>({...f,is_exempt:e.target.checked,is_zero_rated:false}))} />
                        Tax Exempt
                      </label>
                      <label style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'13px', cursor:'pointer' }}>
                        <input type="checkbox" checked={taxCatForm.is_zero_rated}
                          onChange={e => setTaxCatForm(f=>({...f,is_zero_rated:e.target.checked,is_exempt:false}))} />
                        Zero Rated (0%)
                      </label>
                    </div>
                    <div style={{ display:'flex', gap:'8px' }}>
                      <button onClick={addTaxCategory} disabled={taxCatSaving}
                        style={{ padding:'8px 20px', background:'#2D5C3F', color:'white', border:'none', borderRadius:'6px', fontSize:'13px', fontWeight:600, cursor:'pointer' }}>
                        {taxCatSaving ? 'Saving...' : 'Save Category'}
                      </button>
                      <button onClick={() => setTaxCatAdding(false)}
                        style={{ padding:'8px 16px', background:'white', color:'#6B7280', border:'1px solid #D1D5DB', borderRadius:'6px', fontSize:'13px', cursor:'pointer' }}>
                        Cancel
                      </button>
                    </div>
                  </div>
                )
              }
            </>
          )}
        </div>
    </Layout>

  );
};

const styles = {
  card: {
    backgroundColor: 'white', borderRadius: '10px', padding: '24px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)', marginBottom: '16px',
    border: '1px solid #E8E8E8'
  },
  cardHeader: {
    display: 'flex', gap: '12px', alignItems: 'flex-start', marginBottom: '20px'
  },
  cardTitle: {
    margin: 0, fontSize: '16px', fontWeight: '700', color: '#1A3A2A'
  },
  cardSubtitle: {
    margin: '2px 0 0', fontSize: '13px', color: '#888'
  },
  label: {
    fontSize: '12px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '6px'
  },
  input: {
    width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #DDD',
    fontSize: '14px', boxSizing: 'border-box', backgroundColor: 'white'
  },
  readOnly: {
    padding: '10px 12px', borderRadius: '6px', border: '1px solid #EEE',
    fontSize: '14px', backgroundColor: '#FAFAFA', color: '#555'
  }
};

export default Settings;
